import React, { useState } from 'react';
import { Form, Button, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const AddUserModal = ({ 
  isOpen, 
  toggle, 
  role, 
  userCreator, 
  onAdded 
}) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');

  const addUser = async () => {
    await userCreator({
      email,
      firstName,
      lastName,
      password,
      role
    });

    onAdded && onAdded();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Add {role}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>{role} Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="abc@example.com" />
          </FormGroup>
          <FormGroup>
            <Label>First Name</Label>
            <Input value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="John" />
          </FormGroup>
          <FormGroup>
            <Label>Last Name</Label>
            <Input value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Smith" />
          </FormGroup>
          <FormGroup>
            <Label>Password</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={addUser}
        >
          Create
        </Button>
        <Button onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddUserModal;
